import React from "react";
import { X } from "lucide-react"; // Import Lucide React for X icon

const NewHeroSection3 = () => {
  const points = [
    {
      title: "You can’t automate everything",
      desc: "AI enhances an automated process by allowing you to analyze data, make predictions, make decisions, and create things.",
    },
    {
      title: "AI isn’t helpful in all scenarios",
      desc: "Every company is nuanced and requires highly-skilled or creative work that AI can’t displace.",
    },
    {
      title: "AI requires manual commands",
      desc: "For example, ChatGPT requires manual prompts and editing, and is typically just one step in a content creation process. We can automate the steps before and after ChatGPT.",
    },
    {
      title: "Manual commands require people and skill",
      desc: "People create bottlenecks and make errors, causing delays in task handoffs and inconsistent quality.",
    },
  ];

  return (
    <div className="bg-white text-black font-sans py-16">
      <div className="container mx-auto px-6 md:px-16">
        <div className="flex flex-col md:flex-row gap-12">
          {/* Left Section */}
          <div className="md:w-1/2">
            <p className="text-gray-500 text-lg">Learn</p>
            <h1 className="text-4xl font-bold mt-2 leading-tight">
              Why <span className="text-blue-600">AI</span> must be combined with{" "}
              <span className="text-blue-600">Automation</span>
            </h1>
          </div>

          {/* Right Section with X Icons and Connecting Lines */}
          <div className="md:w-1/2 relative flex flex-col">
            {points.map((item, index) => (
              <div key={index} className="relative flex items-start">
                {/* X Icon */}
                <div className="relative z-10 w-6 h-6 flex items-center justify-center text-blue-600">
                  <X size={20} strokeWidth={2.5} />
                </div>

                {/* Connecting Line (Only between items) */}
                {index !== points.length  && (
                  <div className="absolute left-3.5 top-6 h-8 w-0.5 bg-blue-400"></div>
                )}

                {/* Content */}
                <div className="ml-6 mb-6">
                  <h2 className="text-xl font-bold text-blue-600">{item.title}</h2>
                  <p className="mt-2 text-gray-700">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewHeroSection3;
